import { useTranslation, type Lang } from "@ecliptica/i18n";
import { Button, Container, EmptyState } from "@ecliptica/ui";
import { Link } from "react-router";
import { pathFor } from "../../lib/lang";

export function NotFoundPage({ lang }: { lang: Lang }) {
  const { t } = useTranslation("common");
  return (
    <Container className="py-32">
      <EmptyState title={t("error.notFound")}>
        <Button asChild variant="outline" className="mt-3">
          <Link to={pathFor(lang)}>{t("action.back")}</Link>
        </Button>
      </EmptyState>
    </Container>
  );
}
